import { render, staticRenderFns } from "./StoricoOrdiniDialog.vue?vue&type=template&id=9e71c146&"
import script from "./StoricoOrdiniDialog.vue?vue&type=script&lang=ts&"
export * from "./StoricoOrdiniDialog.vue?vue&type=script&lang=ts&"
import style0 from "./StoricoOrdiniDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports